import { Component } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'restricted-product-support-button', // Mark this component as standalone
  imports: [CommonModule, MatIconModule, MatTooltipModule], // Import necessary modules
  templateUrl: './support-button.component.html',
  styleUrls: ['./support-button.component.scss'],
})
export class SupportButtonComponent {
  /* istanbul ignore next */
  openSupportPage() {
    window.open(
      'https://auth.allegion.com/samlp/15ifRUv6OVSrkyRQDVOhoisETC5eEOp6?RelayState=https://support.restrictedproduct.allegion.com/hc/en-us',
      '_blank'
    )
  }
}
